import { get } from 'lodash';
import { UserSimple } from '~/types/models';

export function getAssigneeId(
  userId: string,
  assigneeMap: Record<string, UserSimple | null>
): string | null {
  const selectedAssignee = get(assigneeMap, userId);
  return get(selectedAssignee, 'id') ?? null;
}
